import { createStyles, makeStyles } from "@material-ui/core";

const darkThemeStyle = makeStyles(theme =>
  createStyles({
    "@global": {
      body: {
        background: "#21495C",
        color: "#fff !important",
      },
      loginFlow: {
        "& $formAction": {
          "& button": {
            backgroundColor: "red",
          },
        },
      },
      ".MuiDrawer-docked": {
        "& .MuiPaper-root": {
          background: "#000",
          border: "none",
          boxShadow: "0px 3px 6px #00000029",
        },
        "& .Mui-selected": {
          borderColor: theme.palette.secondary.main,
        },
        "& .MuiListItemIcon-root": {
          "& img": {
            filter: "brightness(0) invert(1)",
          },
        },
        "& .MuiIconButton-root": {
          "& img": {
            filter: "brightness(0) invert(1)",
          },
        },
        "& .Mui-selected": {
          borderRightColor: "#ABE228",
          "& img": {
            filter:
              "invert(25%) sepia(52%) saturate(680%) hue-rotate(40deg) brightness(99%) contrast(85%)",
          },
        },
      },
      ".MuiPaper-root": {
        background: "#2A5E77",
        color: "#fff !important",
        "& span[class*='errorMessages']": {
          color: "#ffb9b8",
        },
        "& span[class*='starMark'], div[class*='errorMessages']": {
          color: "#ffb9b8",
        },
      },
      ".page-header": {
        background: "#21495C !important",
      },
      ".MuiAppBar-root": {
        background: "transparent",
        "& .MuiTabs-root button": {
          opacity: 1,
          "& span": {
            color: "#fff",
          },
        },
      },
      header: {
        "&.MuiAppBar-root": {
          background: "transparent",
          border: "none",
          "& span": {
            color: "#fff",
          },
        },
        "&.MuiAppBar-positionFixed": {
          background: "#2A5E77",
          "& a": {
            "& img": {
              filter: "brightness(0) invert(1)",
            },
          },
        },
        "& .MuiBadge-badge": {
          background: theme.palette.secondary.main,
          borderColor: theme.palette.secondary.main,
          color: "#000 !important",
        },
      },
      ".f-gray": {
        color: "#c5c5c5",
      },
      ".MuiInputLabel-asterisk": {
        color: "#ffb9b8 !important",
      },
      ".MuiInputBase-input": {
        color: "#fff",
      },
      ".MuiFormLabel-root": {
        color: "#fff !important",
      },
      ".MuiFormLabel-root.Mui-disabled": {
        color: "#9d9d9d !important",
      },
      ".MuiInput-underline.Mui-error:after": {
        borderBottomColor: "#ffb9b8",
      },
      ".MuiSelect-icon": {
        color: "#fff",
      },
      ".k-grid, .k-pager-wrap, .k-header .k-link, .k-grid-content": {
        background: "transparent",
        color: "#fff",
      },
      ".k-grid-header .k-sorted, .k-grid-header .k-link:hover": {
        color: "#ccc",
      },
      ".k-grid table tbody tr:hover": {
        background: "#dff1fa",
      },
      ".k-grid a, .k-grid button": {
        background: "transparent",
      },
      ".k-grid table tbody tr:hover": {
        background: "#2d424c",
        color: "#ccc",
      },
      ".k-grid": {
        "& td[class*='errorMsg']": {
          color: "#ffb9b8",
        },
      },
      ".k-pager-numbers .k-link.k-state-selected": {
        color: "#fff",
      },
      ".k-dropdown .k-dropdown-wrap, .k-dropdowntree .k-dropdown-wrap": {
        color: "#fff",
        borderColor: "#777",
      },
      ".k-i-more-vertical::before": {
        color: "#fff",
      },
      ".k-grid-header": {
        borderTop: "solid 1px #ccc",
        borderBottom: "solid 1px #ccc",
      },
      ".k-pager-numbers .k-link": {
        color: "#fff",
      },
      ".k-link.k-pager-nav": {
        background: "#21495c",
      },
      ".MuiPickersCalendarHeader-iconButton": {
        background: "none !important",
        color: "#fff",
      },
      ".MuiPickersCalendarHeader-dayLabel, .MuiPickersCalendar-week button": {
        color: "#fff",
      },
      ".MuiPickersDay-dayDisabled": {
        opacity: 0.3,
      },
      ".MuiInput-root, .MuiFormLabel-root": {
        "& svg": {
          color: "#fff",
        },
        "& img": {
          filter: "brightness(0) invert(1)",
        },
      },
      ".MuiAutocomplete-option": {
        background: "none !important",
      },
      ".MuiButton-outlinedPrimary": {
        background: "none",
        border: "solid 1px #07B26C",
        "&:hover": {
          background: "#fff",
        },
      },
      ".MuiDropzoneArea-root": {
        background: "#2a5e77",
        "& p": {
          color: "#fff !important",
        },
        "& svg": {
          color: "#fff !important",
        },
      },
      ".k-grouping-row span": {
        color: "#fff",
      },
      ".avatar-bg": {
        background: "#27576e",
        color: "#ccc !important",
      },
      ".MuiChip-clickable.MuiChip-outlined:hover, .MuiChip-clickable.MuiChip-outlined:focus, .MuiChip-deletable.MuiChip-outlined:focus":
      {
        background: "#21495c",
        color: "#ccc",
      },
    },
  })
);

export default darkThemeStyle;
